import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from './Images/cab-logo.svg'
import { Dropdown } from "antd";
import { UserOutlined } from '@ant-design/icons';

const Header = () => {
    const navigate = useNavigate();

    const ProfileItems = [
        {
            key: '1',
            type: 'group',
            children: [
                {
                    key: 'updatePassword',
                    label: 'Update Password'
                },
                {
                    key: 'logout',
                    label: 'Logout'
                },
            ]
        }
    ]

    
    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('isLoggedIn');
        navigate('/login');
    }

    return (
        <>
            <header className=" bg-[#E0F1F6] sticky top-0 w-full z-10">
                <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8">
                    <div className="flex justify-between lg:flex-1">
                        <Link to='/' className="-m-1.5 p-1.5">
                            <div className=' flex items-center py-2'>
                                <span className="sr-only">Your Company</span>
                                <img className="shadow-2xl p-1 border border-gray-200 rounded-md h-16 w-16" alt="Logo" src={Logo} />
                                <div className=" text-center ms-1 leading-tight">
                                    <p className=" font-bold text-xl text-[#E8103F] leading-none"> UrbanCab <br /> <span className="text-gray-500">Partner</span></p>
                                </div>
                            </div>
                        </Link>
                        <div className="absolute inset-y-0 right-0 flex items-center pr-0 md:pr-2 sm:static sm:inset-auto sm:ml-4 sm:pr-0 gap-2 md:gap-10">
                            <div className='cursor-pointer flex-col justify-items-center'>
                                <Dropdown
                                    overlayStyle={{
                                        width: "200px"
                                    }}
                                    trigger={['hover', "click"]}
                                    menu={{
                                        items: ProfileItems,
                                        // onClick:{showModal}
                                        onClick: ({ key }) => key === 'updatePassword' ? navigate('/admin/changepassword') : handleLogout() }}
                                    mode="vertical"
                                >
                                    <div className='cursor-pointer flex-col justify-items-center group'>
                                        <p className='md:text-sm sm:text-[10px] text-[10px] text-[#000000] group-hover:text-[#FF6E19] mt-1'> <UserOutlined /> Admin</p>
                                    </div>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
        </>
    );
}

export default Header;